import React from "react";
import PropTypes from "prop-types";
import InspectionProcessCard from "../inspection-process-card/component";
import styles from "./styles.css";
import ProcessIconOne from "./images/process-1.svg";
import ProcessIconTwo from "./images/process-2.svg";
import ProcessIconThree from "./images/process-3.svg";
import ProcessIconFour from "./images/process-4.svg";
import ProcessIconFive from "./images/process-5.svg";
import ProcessIconSix from "./images/process-6.svg";
import Button from "../../shared/button";
import getResumeFilterListingUrl from "../../../utils/helpers/get-resume-filter-listing-url";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const InspectionProcess = ({
    reloadCarListConnect,
    resetCarListConnect,
    updateSelectedOnScreenFilterConnect,
    clearAllFiltersConnect
}) => {

    const onClickListingPage = () => {
        const absoluteURL = getResumeFilterListingUrl();
        resetCarListConnect();
        reloadCarListConnect(true);
        updateSelectedOnScreenFilterConnect("");
        clearAllFiltersConnect();
        // trackEvent("find_car");
        window.location.href = absoluteURL;
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.THREE_HUNDRED_CTA);
        window.setTimeout(() => window.scrollTo(0, 0));
    };

    return (
        <section styleName={"styles.inspectionProcessWrap"}>
            <div className="container">
                <h2>Cars24 <span>300 point inspection</span> process</h2>
                <div styleName={"styles.processCardGrid"}>
                    <InspectionProcessCard>
                        <h3><span>1. Initial inspection</span> once we receive the car</h3>
                        <img src={ProcessIconOne} />
                    </InspectionProcessCard>
                    <InspectionProcessCard>
                        <h3><span>2. All-inclusive</span> mechanical inspection + roadworthy check</h3>
                        <img src={ProcessIconTwo} />
                    </InspectionProcessCard>
                    <InspectionProcessCard>
                        <h3><span>3.</span> External paint and panel review <span>+ refurbishment</span></h3>
                        <img src={ProcessIconThree} />
                    </InspectionProcessCard>
                    <InspectionProcessCard>
                        <h3><span>4.</span> Final <span>quality check</span> by a senior technician to double-check all points </h3>
                        <img src={ProcessIconFour} />
                    </InspectionProcessCard>
                    <InspectionProcessCard>
                        <h3><span>5. Full internal + external detail</span> (car wash + polish, steam clean, stain removal, glass, deodorising)</h3>
                        <img src={ProcessIconFive} />
                    </InspectionProcessCard>
                    <InspectionProcessCard>
                        <h3><span>6. Full feature functionality</span> check (i.e. power windows, infotainment, climate control, seat heaters)</h3>
                        <img src={ProcessIconSix} />
                    </InspectionProcessCard>
                </div>
                <div styleName={"styles.ctaWrap"}>
                    <Button isUpperCase text="Find Your Car" onClick={onClickListingPage}/>
                </div>
            </div>
        </section>
    );
};

InspectionProcess.propTypes = {
    reloadCarListConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func
};

export default InspectionProcess;
